// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"462b5838","203":"852d265d","213":"5df27640","754":"fdf3171e"}[chunkId] + ".chunk.css";
};